import { EnrollmentHelper } from './helpers/enrollment-helper';
import { LupHelper } from './helpers/lup-helper';
import { InsightsService } from './insights-service/insights-service';
import { TimeTrackingHealthService } from './progression/time-tracking/health/time-tracking-health-service';
import { TincanHealthService } from './progression/tincan/health/tincan-health-service';
import { TelemetryService } from './telemetry/telemetry-service';
import { throttle } from '../shared/util/throttle';
import { retry } from '../shared/util/retry';
import type { RetryOptions } from '../shared/util/retry';

export const CrossFrameworkLib = {
  mode: import.meta.env.MODE,
  LupHelper,
  InsightsService,
  EnrollmentHelper,
  TincanHealthService,
  TimeTrackingHealthService,
  TelemetryService,
  throttle,
  retry,
};

export type CrossFrameworkLib = typeof CrossFrameworkLib;
export type { RetryOptions };

/**
 * Checks if the CrossFrameworkLib object is already present in the global window object and if the current mode is 'development'.
 * If either condition is false, it attaches the CrossFrameworkLib object to the window object.
 *
 * This ensures that the library is only initialized once and allows for re-initialization in a development environment for testing purposes.
 */
const hasCrossFrameworkLib = 'CrossFrameworkLib' in window;
const isDevelopment = window?.CrossFrameworkLib?.mode === 'development';

if (!hasCrossFrameworkLib || !isDevelopment) {
  window.CrossFrameworkLib = CrossFrameworkLib;
}

window.dispatchEvent(new CustomEvent('cross-framework-lib:ready'));

declare global {
  interface Window {
    CrossFrameworkLib: typeof CrossFrameworkLib;
  }
}
